import React from 'react';

import { Checkbox as ChakraCheckbox, Flex, Box } from '@chakra-ui/react';

import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const CheckBoxLabel = ({ label, subLabel }) => (
  <Flex flexDir="column" ml="4px">
    <TextBodyMedium bold>{label}</TextBodyMedium>
    {subLabel && <TextLabel color="text.g2">{subLabel}</TextLabel>}
  </Flex>
);

const MainBottomConnector = () => (
  <Box w="1px" bg="border.CFD7DF" position="absolute" h="22px" left="24px" bottom={0} />
);

const SubOptionVerticalConnector = ({ fullHeight = false }) => (
  <Box w="1px" bg="border.CFD7DF" position="absolute" h={fullHeight ? '100%' : '50%'} left="24px" top="0px" />
);

const SubOptionHorizontalConnector = () => (
  <Box bg="border.CFD7DF" position="absolute" w="14px" h="1px" left="24px" top="29px" />
);

const NestedCheckbox = ({
  options = [],
  selectedOptionsKeys = [],
  onChange,
  allOptionsLabel,
  allOptionsSubLabel,
  // for the purpose of events firing
  onAllChange,
  onSubOptionChange,
}) => {
  const handleOnChange = (changedOptionKey) => {
    if (onSubOptionChange) {
      onSubOptionChange(changedOptionKey);
    }
    if (!selectedOptionsKeys.includes(changedOptionKey)) {
      onChange([...selectedOptionsKeys, changedOptionKey]);
    } else {
      onChange(selectedOptionsKeys.filter((key) => key !== changedOptionKey));
    }
  };

  const handleAllOnChange = () => {
    if (onAllChange) {
      onAllChange();
    }
    if (options.length === selectedOptionsKeys.length) {
      onChange([]);
    } else {
      onChange(options.map(({ key }) => key));
    }
  };

  const isAllChecked = options.length === selectedOptionsKeys.length;

  return (
    <Flex flexDir="column">
      {options.length > 0 && (
        <Flex flexDir="column" pos="relative">
          <ChakraCheckbox isChecked={isAllChecked} onChange={() => handleAllOnChange()} py={3} px={4}>
            <CheckBoxLabel label={allOptionsLabel} subLabel={allOptionsSubLabel} />
          </ChakraCheckbox>
          <MainBottomConnector />
        </Flex>
      )}
      {options.map(({ label, key, subLabel }, idx) => {
        const isChecked = selectedOptionsKeys.includes(key);
        return (
          <Flex pos="relative" alignItems="center">
            <SubOptionVerticalConnector fullHeight={idx < options.length - 1} />
            <SubOptionHorizontalConnector />
            <ChakraCheckbox isChecked={isChecked} onChange={() => handleOnChange(key)} py={3} px="44px">
              <CheckBoxLabel label={label} subLabel={subLabel} />
            </ChakraCheckbox>
          </Flex>
        );
      })}
    </Flex>
  );
};

export { NestedCheckbox };
